import React from 'react';
import { Select } from 'antd';
import { getAllowedGranularity, GranularityMap } from '@components/common/GranularitySelect/utils';
import { useAtom, useAtomValue } from 'jotai';
import { granularityAtom, intervalAtom } from '@src/components/usage-dashboard/atoms';
import { GRANULARITY } from '@utils/granularity';
import { StyledGranularity } from '../styled';
import { IGranularityPickerProps } from './typed';
import { StyledSpace } from './styled';

const GranularityPicker: React.FC<IGranularityPickerProps> = ({ disabled }) => {
  const [granularity, setGranularity] = useAtom(granularityAtom);
  const interval = useAtomValue<Date[]>(intervalAtom);

  const allowedGran = getAllowedGranularity({ from: interval[0], to: interval[1] }, true);
  let defaultValue;
  const options = Object.values(GranularityMap).filter((option) => {
    if (option.value === granularity) {
      defaultValue = option;
    }
    if (option.value === GRANULARITY.PT10S) return false;
    return allowedGran.includes(option.value);
  });

  return (
    <StyledSpace disabled={disabled}>
      <StyledGranularity>Granularity:</StyledGranularity>
      <Select
        defaultValue={defaultValue}
        onChange={setGranularity}
        style={{ width: 100 }}
        options={options}
        value={defaultValue}
        disabled={disabled}
      />
    </StyledSpace>
  );
};

export default GranularityPicker;
